<template>
	<div class="bigDiv" >
		<div v-text="title" style="font-size:0.36rem; margin: 0.34rem auto;"></div>
		<div class="videos" style="position: relative;">
			<div class="shade"  @click="lj()"  v-if="types == '2'">
				
			</div>
			<video :poster="videoCover"   class="videos" :src="videoUrl" controls="controls" webkit-playsinline="true" >
			</video>
		</div>
		

	</div>
		
</template>
<script>
	import request from '@/utils/request'
	export default {
		components: {

		},
		data() {
			return {
				title:'',
				videoCover:'',
				videoUrl:'',
				types:1,
			}
		},
		mounted() {
			this.isIphone();
			this.initData();
			
		},
		methods: {
			isIphone(){
				let _this = this;
				 if (/(Android)/i.test(navigator.userAgent)) {   //判断Android
						_this.types = '2';
				}
			},
			initData() {
				let _this = this;
				let url = Global.env + Global.apiCore.helpDetails+"/"+this.$route.query.id;
				// let url = Global.env + Global.apiCore.helpList;
				return new Promise((resolve, reject) => {
					request({
						url: url,
						method: 'get', //查询一般为get
					}).then(response => {
						if (response.resultCode === "1000") {
							let obj = response.data;
							this.title = obj.title;
							this.videoCover = obj.videoCover;
							this.videoUrl = obj.videoUrl;
							return resolve()
						}
					}).catch(error => {
						return reject(error);
					})
				})
			},
			lj(){
				window.location.href = this.videoUrl;
			}
		}
	}
</script>

<style>
	.bigDiv {
		width: 92% !important;
		text-align: justify;
		margin: 0 auto;
	}
	.videos{
			width: 100%;
			height: 4.48rem;
			margin: 0 auto;
			border-radius: 0.2rem;
			box-shadow:0px 0.08rem 0.58rem 0px rgba(117,117,117,0.11);
	}
	.shade{
		width: 100%;
		height: 4.48rem;
		border-radius: 0.2rem;
		background: rgba(8, 8, 8, 0.2); 
		position: absolute;
		left: 0;
		top: 0;
		z-index: 99999;
		cursor: pointer;
	}
</style>
